import type {
  IRecommendedCarClickEvent,
  IRecommendedCarClickInput,
} from '../types/clickEvents';
import { buildRecommendationsObject } from '../utils/buildRecommendationsObject';

const recommendedCarClick = (
  input: IRecommendedCarClickInput,
): Omit<IRecommendedCarClickEvent, 'event'> => ({
  linkDetails: input.linkDetails,
  ...(input.moduleExperience
    ? { module: { moduleExperience: input.moduleExperience } }
    : {}),
  recommendations: {
    carouselLength: input.recommendations.items.length,
    stockNumber: input.recommendations.items[0]?.stockNumber,
    sameVehicle: input.sameVehicle,
    ...buildRecommendationsObject(
      input.carouselKey,
      input.recommendations.items.map(item => item.stockNumber),
    ),
  },
});

export default recommendedCarClick;
